var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"tw-flex tw-items-center",class:_vm.value ? 'tw-text-black' : 'tw-text-gray-500'},[_c('i',{staticClass:"far tw-mr-3 tw-w-2",class:_vm.value ? 'fa-check tw-text-green-500' : 'fa-times tw-text-gray-400'}),_vm._v(" "+_vm._s(_vm.translation)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }